const Privacy = () => {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h3 className="mt-5 mb-4">Privacy Policy</h3>
            <h5>The Information We Collect:</h5>
            <p>
              This notice applies to all information collected or submitted on our app. The types of personal information collected are name, Email address, Phone number(etc.)
            </p>
            <h5>The Way We Use Information</h5>
            <p>
            We do not share this information with any third party outside. We use email addresses to send you work related informations. Such addresses are not used for any other purpose and are not shared with outside parties. Finally, we never use or share the personally identifiable information provided to us online in ways unrelated to the ones described above without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.
            </p>
            <h5>Our Commitment To Data Security:</h5>
            <p>
            To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, we have put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online.
            </p>
            <h5>How To Contact Us</h5>
            <p>
            Should you have other questions or concerns about these privacy policies, please visit our support us page.</p>
          </div>
        </div>
      </div>
    );
  };
  
  export default Privacy;
  